import React from "react";
import { Outlet } from "react-router-dom";
import CommonLayout from "../../pages/Layouts/CommonLayout";
import useReports from "./useReports";

const Reports = () => {
  const { drawerMenu } = useReports();
  return (
    <CommonLayout drawerMenu={drawerMenu} >
      <Outlet />
    </CommonLayout>
  );
};

export default Reports;
